import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBrandsData } from "../../../redux/BrandsSlice";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";
import "./Reefy.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import { Link } from "react-router-dom";
import GoToBImg from "../../../Assets/Svg/Home/Arrow_Up_Ar.svg";
import ProductsSlider from "../../../Component/ReuseComponent/Products/ProductsSlider";
import ProductsSliderRight from "../../../Component/ReuseComponent/Products/ProductsSliderRight";
import { mapProducts } from "../../../Component/ReuseComponent/mapProducts/mapProducts";

export default function ReefyContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { section, brands } = useSelector((state) => state.brands);

  useEffect(() => {
    if (!section || section.length === 0 || brands.length === 0) {
      dispatch(fetchBrandsData({ page_id: 5, lang: "ar" }));
    }
  }, [dispatch, section, brands]);

  // section 1
  const section1 = section.find((s) => s.section_id === "1");

  //  section 3 products
  const section4 = section.find((s) => s.section_id === "4");

  const reefyBrands = brands?.filter((b) => b.page_id === 5) || [];

  // section 1 title and section 2 products = milk
  const section2 = reefyBrands.find((s) => s.section_id === 2);
  const milk = section2?.products || [];

  // section 2 products
  const section3 = reefyBrands.find((s) => s.section_id === 3);
  const yogurts = section3?.products || [];

  return (
    <>
      <LoaderWrap>
        <div className="ReefyContainer">
          <section>
            <ReefyS1 section1={section1} section2={section2} milk={milk} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="ReefyS2">
            <ReefyS2 section3={section3} yogurts={yogurts} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="ReefyS3">
            <ReefyS3 section4={section4} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}

function ReefyS1({ section1, section2, milk }) {
  const sentences = section1?.description?.split(".").filter(Boolean) || [];

  const Para = sentences
    .map((s, i) => {
      const sentence = s.trim();
      if (i < 2) return sentence + ". ";
      if (i === 2) return sentence + ".<br /><br />";
      return sentence + ".";
    })
    .join("")
    .trim();

  const product = mapProducts(milk);
  if (product.length === 0) return null;

  return (
    <>
      <div className="ReefyS1">
        {" "}
        <div className="TheMilkmanS1">
          <div>
            <img src={section1?.image} alt="" />
          </div>
          <TC3L
            Para={
              <>
                <div dangerouslySetInnerHTML={{ __html: Para }} />
              </>
            }
            ParaWidth="56vw"
          />
        </div>
        <div className="RESP2">
          <TC3L Title={section2?.title} />
          <div className="ProductSliderPage">
            <ProductsSlider products={product} />
          </div>
        </div>
      </div>
    </>
  );
}

function ReefyS2({ section3, yogurts }) {
  const product = mapProducts(yogurts);

  if (product.length === 0) return null;
  return (
    <>
      <div className="ReefyS2">
        <div className="MMSP2">
          <TC3L Title={section3?.title} />
          <div className="ProductSliderPage">
            <ProductsSliderRight products={product} />
          </div>
        </div>
      </div>
    </>
  );
}

function ReefyS3({ section4 }) {
  return (
    <>
      <div className="ReefyS3">
        <div>
          <TC3L Title={section4?.title} Para={section4?.description} ParaWidth="42vw" />
        </div>
        <div className="BoxPPC">{section4?.links && section4?.links.map((link, index) => <SocialLink key={index} href={link.link} text={link.name} />)}</div>
      </div>
    </>
  );
}

function SocialLink({ href, text }) {
  return (
    <Link to={href} target="blank" className="BoxPPCA">
      <div>
        <img src={GoToBImg} alt="" className="BoxImgTPB_ButtonC_Img_New" />
      </div>
      <div className="BoxImgTPB_ButtonC_Text ar">{text}</div>
    </Link>
  );
}
